module.exports = __webpack_public_path__ + "static/flags/KE-7fd769bd7aaeb4704dd3578433054279.gif";